import React from "react";

import "./Footer.scss";

const FooterText = () => (
    <div>
    <p className="footer-text">©{new Date().getFullYear()} All Right Reserved By AK NIBIR</p>
  </div>
);

export default FooterText;
